import { DocumentFileIcon } from '@room-match/shared-ui-components';
import React from 'react';
import { FileCont, FileName } from './MediaItem.styles';

interface Props {
  src: string;
  fileName: string;
}

const FIleItem: React.FC<Props> = ({ src, fileName }) => {
  return (
    <FileCont onClick={() => window.open(`${src}`, '_blank')}>
      <DocumentFileIcon className="documentIcon" />
      <FileName style={{ marginLeft: 10 }}>{fileName}</FileName>
    </FileCont>
  );
};

export default FIleItem;
